import { render, staticRenderFns } from "./SectorGoals.vue?vue&type=template&id=c778c676&"
import script from "./SectorGoals.vue?vue&type=script&lang=js&"
export * from "./SectorGoals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports